import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { globalMapService, GlobalMapData } from '@/services/global-map-service'
import { toast } from 'sonner'

export function useGlobalMap() {
    const queryClient = useQueryClient()

    const globalMapQuery = useQuery({
        queryKey: ['global-map-page'],
        queryFn: () => globalMapService.getGlobalMap(),
    })

    const updateGlobalMapMutation = useMutation({
        mutationFn: (data: Partial<GlobalMapData>) =>
            globalMapService.updateGlobalMap(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['global-map-page'] })
            toast.success('Harita istatistikleri güncellendi')
        },
        onError: (error: any) => {
            console.error('API Error:', error)
            toast.error('Güncelleme sırasında bir hata oluştu')
        },
    })

    return {
        globalMap: globalMapQuery.data,
        isLoading: globalMapQuery.isLoading,
        isError: globalMapQuery.isError,
        updateGlobalMap: updateGlobalMapMutation.mutateAsync,
        isUpdating: updateGlobalMapMutation.isPending
    }
}
